import React from "react";
import {TextField, MenuItem} from "@material-ui/core";
import {useCity} from "../../CityContext";

// Thin UI layer over CityContext (the actual fetch/merge/persist logic
// lives there, shared with anything that needs to filter by the selection
// — see Components/Orders.js).
const CitySelect = () => {
  const {cityOptions, selectedCityValue, setSelectedCityValue} = useCity();

  if (cityOptions.length === 0) {
    return null;
  }

  return (
    <TextField
      select
      value={selectedCityValue}
      onChange={(event) => setSelectedCityValue(event.target.value)}
      size="small"
      fullWidth
      style={{margin: '0 0 12px'}}
    >
      {cityOptions.map((option) => (
        <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
      ))}
    </TextField>
  );
};

export default CitySelect;
